import Pikaday from 'pikaday'

export default class InputDate
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...InputDate.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$input = this.DOM.$el.querySelector(this.options.selectorInput)
        this.DOM.$inputFormatted = this.DOM.$el.querySelector(this.options.selectorInputFormatted)

        this.pikaday = new Pikaday({
            field: this.DOM.$inputFormatted,
            firstDay: 1,
            i18n: window.i18n,
            onSelect: this.onSelect.bind(this),
            toString: this.toString.bind(this),
        })
    }

    onSelect(date) {
        const d = ('0' + date.getDate()).substr(-2)
        const m = ('0' + date.getMonth()).substr(-2)
        const y = date.getFullYear()

        this.DOM.$input.value = `${y}-${m}-${d}`
    }

    toString(date) {
        const d = date.getDate()
        const m = window.i18n.months[date.getMonth()]
        const y = date.getFullYear()

        return `${d} ${m} ${y}`
    }
}

InputDate.prototype.defaults = {
    selectorInput: '.js-inputDateInput',
    selectorInputFormatted: '.js-inputDateInputFormatted',
}